import { CustomTable, InputDate } from "medere-ui-framework"
import { useId, useRef, useState, BaseSyntheticEvent } from "react"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { useOperatorService } from "../servicesHooks/Operator/useOperatorService"

function OperatorActionsReportView() {
    const { getOperatorActionsReport, exportOperatorActionsReport } = useOperatorService();

    const tableRef = useRef(null)
    const today = new Date()
    const [initialDateTime, setInitialDateTime] = useState<Date>(generateFromDate())
    const [finalDateTime, setFinalDateTime] = useState<Date>(generateToDate())

    function generateFromDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = 1;

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    function generateToDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());
      
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
      
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;
      
        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;
      
        return new Date(formattedDate);
    }

    return (
        <div className="p-4 flex flex-column viewContainer">
            <h2 className="text-2xl">Acciones de Operadores</h2>
            <div className='flex align-items-end justify-content-between gap-3'>
                <div className="flex flex-row gap-3 w-1/2">
                    <InputDate value={initialDateTime} label='Desde' onChange={(e: BaseSyntheticEvent) => {
                        setInitialDateTime(e.target.value)
                    }}
                        className='w-1/2'
                        maxDate={today}
                    />

                    <InputDate value={finalDateTime} label='Hasta' onChange={(e: BaseSyntheticEvent) => {
                        setFinalDateTime(e.target.value)
                    }}
                        className='w-1/2'
                        maxDate={today}
                    />
                </div>
            </div>

            <CustomTable
                idTable={useId()}
                ref={tableRef}
                showGridlines
                hideFiltersButton
                getItems={getOperatorActionsReport}
                params={{
                    initialDateTime: initialDateTime,
                    finalDateTime: finalDateTime
                }}
                exportItems={[{ label: "Excel", icon: "pi-file-excel", onExport: exportOperatorActionsReport }]}
                className='crudTable'
            >
                <Column field="turnnumber" header="Nro Turno" className="columnGen columnPdLeft" />
                <Column field="_action" header="Acción" className="columnGen columnPdLeft" />
                <Column field="date" header="Fecha" className="columnGen columnDt" body={(record) => {
                    const formattedDate = new Date(record.date).toLocaleString('es-ES');
                    return <span>{formattedDate}</span>;
                }}/>
                <Column field="usernumber" header="Nro Usuario" className="columnGen columnPdLeft" />
                <Column field="username" header="Usuario" className="columnGen columnSt" />
                <Column field="profilenumber" header="Nro Perfil" className="columnGen columnPdLeft" />
                <Column field="profile" header="Perfil" className="columnGen columnPdLeft" />
                <Column field="patientnumber" header="Nro Paciente" className="columnGen columnPdLeft" />
                <Column field="patient" header="Paciente" className="columnGen columnPdLeft" />
                <Column field="document" header="DNI" className="columnGen columnPdLeft" />
            </CustomTable>
        </div>
    )
    

}

export default OperatorActionsReportView;
